import { render, staticRenderFns } from "./needwx.vue?vue&type=template&id=238d27fc&scoped=true&"
import script from "./needwx.vue?vue&type=script&lang=js&"
export * from "./needwx.vue?vue&type=script&lang=js&"
import style0 from "./needwx.vue?vue&type=style&index=0&id=238d27fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d27fc",
  null
  
)

export default component.exports